import React from "react";
import { m } from "framer-motion";

const MissionSection = () => {
  return (
    <section className="flex flex-col bg-auto-black/5">
      <div className="container flex items-center justify-center px-4 py-16">
        <m.div
          className="flex max-w-[960px]  shrink grow basis-0 flex-col items-center justify-center gap-6"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2
            id="mission"
            className="self-stretch p-0 text-center text-3xl font-bold leading-9 text-primary-700"
          >
            Our Mission
          </h2>
          <div className="flex items-center justify-center gap-2 self-stretch">
            <div className="shrink grow basis-0 text-center text-xl font-medium leading-[30px] text-auto-black/60">
              At AlHayat Foodstuff, we are committed to transforming the global
              frozen vegetables market with premium-quality products. Guided by
              transparency, commitment, and sustainability, we've transitioned
              to global distribution, building lasting partnerships. Sourcing
              directly from farmers, we ensure unparalleled quality control and
              flexibility, offering sustainable solutions to meet diverse
              customer specifications.
            </div>
          </div>
        </m.div>
      </div>
    </section>
  );
};

export default MissionSection;
